import { useTranslation } from 'react-i18next';
import { Asset } from '@/types/assets';
import { AssetDetailsBaseCard } from '@/pages/Assets/AssetDetailsContent/AssetDetailsBaseCard';
import { Flex, Link, spaces } from '@electricjs/arc';
import AssetDetail from '@/components/Assets/AssetDetails/AssetDetail';
import formatDate from '@/helpers/formatDate';
import formatCurrency from '@/helpers/formatCurrency';

type PurchaseInformationDetailsCardProps = {
  asset: Asset;
};

const PurchaseInformationDetailsCard = ({
  asset,
}: PurchaseInformationDetailsCardProps) => {
  const { t } = useTranslation('assets');
  const { space_m, space_xl } = spaces;

  return (
    <AssetDetailsBaseCard
      title={t('assetDetailsContent.purchaseInformation')}
      icon="shopping-cart">
      <Flex
        flexDirection="column"
        width="100%"
        gap={space_m}
        px={space_m}
        mt={space_m}>
        <Flex flexDirection="column" width="100%" gap={space_m} pl={space_xl}>
          <AssetDetail
            label={t('assetDetailsContent.purchaseDate')}
            labelVariant="label-small"
            value={
              asset.purchaseDate
                ? formatDate(asset.purchaseDate)
                : t('deviceSecurityPanel.notApplicable')
            }
            valueVariant="body-2"
          />
          <AssetDetail
            label={t('assetDetailsContent.purchasePrice')}
            labelVariant="label-small"
            value={
              asset.purchasePrice !== undefined && asset.purchasePrice !== null
                ? formatCurrency(
                    asset.purchasePrice,
                    asset.purchasePriceCurrencyCode
                  )
                : t('deviceSecurityPanel.notApplicable')
            }
            valueVariant="body-2"
          />
          <AssetDetail
            label={t('assetDetailsContent.purchasedFrom')}
            labelVariant="label-small"
            value={
              asset.purchasedFromUrl ? (
                <Link
                  variant="body-2"
                  target="_blank"
                  rel="noopener"
                  href={asset.purchasedFromUrl}>
                  {asset.purchasedFromUrl}
                </Link>
              ) : (
                t('deviceSecurityPanel.notApplicable')
              )
            }
            valueVariant="body-2"
          />
          <AssetDetail
            label={t('assetDetailsContent.warrantyExpiration')}
            labelVariant="label-small"
            value={
              asset.warrantyExpirationDate
                ? formatDate(asset.warrantyExpirationDate)
                : t('deviceSecurityPanel.notApplicable')
            }
            valueVariant="body-2"
          />
        </Flex>
      </Flex>
    </AssetDetailsBaseCard>
  );
};

export default PurchaseInformationDetailsCard;
